module.exports = __webpack_public_path__ + "img/Wheelchair.944992d5.svg";